import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-screen">
                    <div className="error-card">
                        <h2 className="error-title">Đã xảy ra lỗi</h2>
                        <p className="error-desc">Ứng dụng gặp sự cố. Vui lòng tải lại trang.</p>
                        <button className="error-reload-btn" onClick={() => window.location.reload()}>Tải lại trang</button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
